<script>
  import { createEventDispatcher } from "svelte";
  import Dropdown from "../../../ui/Dropdown.svelte";

  export let campaign = {};
  export let busy = false;

  const dispatch = createEventDispatcher();
  const assignmentOptions = [
    { value: "MANUAL", label: "Manual" },
    { value: "AUTO", label: "Automática" },
  ];

  let assignationMode = "";
  let bonusAmount = "";
  let errorMessage = "";
  let campaignSnapshot = "";

  $: maximumBonusAmount = campaign?.sportsConfig?.maximumBonusAmount;
  $: bonusType = String(campaign?.providerCampaignType ?? campaign?.bonusType ?? "").trim().toUpperCase();
  $: isCashback = bonusType === "CASHBACK";
  $: requiresBonusAmount = ["FREE_BET", "RISK_FREE_BET"].includes(bonusType);
  $: hasMaximumBonusAmount =
    maximumBonusAmount !== null &&
    maximumBonusAmount !== undefined &&
    maximumBonusAmount !== "" &&
    Number.isFinite(Number(maximumBonusAmount)) &&
    Number(maximumBonusAmount) !== 0;

  $: {
    const nextSnapshot = String(campaign?.campaignId ?? campaign?.id ?? "");
    if (nextSnapshot !== campaignSnapshot) {
      campaignSnapshot = nextSnapshot;
      assignationMode = String(campaign?.assignationMode ?? "").toUpperCase();
      bonusAmount = campaign?.sportsConfig?.bonusAmount ?? "";
      errorMessage = "";
    }
  }

  function save() {
    errorMessage = "";
    const hasAmount = String(bonusAmount ?? "").trim() !== "";
    const amount = hasAmount ? Number(bonusAmount) : null;
    if (!assignmentOptions.some((option) => option.value === assignationMode)) {
      errorMessage = "Selecciona el tipo de asignación.";
      return;
    }
    if (assignationMode === "AUTO" && requiresBonusAmount && (!hasAmount || !Number.isFinite(amount) || amount <= 0)) {
      errorMessage = "El monto del bono debe ser mayor que cero.";
      return;
    }
    if (assignationMode === "AUTO" && !isCashback && amount !== null && hasMaximumBonusAmount && amount > Number(maximumBonusAmount)) {
      errorMessage = `El monto del bono no puede superar ${campaign?.currency || ""} ${maximumBonusAmount}.`;
      return;
    }
    dispatch("save", {
      assignationMode,
      bonusAmount: assignationMode === "AUTO" && !isCashback ? amount : null,
    });
  }
</script>

<div class="modal-backdrop fade show" aria-hidden="true"></div>
<div class="modal d-block" tabindex="-1" style="background:rgba(0,0,0,.3);">
  <div class="modal-dialog modal-dialog-centered config-modal">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h5 class="modal-title">Configurar Sport Bonus</h5>
          <div class="campaign-name">{campaign?.campaignName || campaign?.campaignId || "—"}</div>
        </div>
        <button type="button" class="btn-close" aria-label="Cerrar" disabled={busy} on:click={() => dispatch("close")}></button>
      </div>

      <div class="modal-body">
        <div class="config-grid" class:single-field={assignationMode !== "AUTO" || isCashback}>
          <div class="field">
            <span class="field-label">Tipo de asignación <span class="required">*</span></span>
            <Dropdown
              options={assignmentOptions}
              bind:value={assignationMode}
              valueKey="value"
              labelKey="label"
              placeholder="Seleccionar tipo..."
              clearable={false}
              disabled={busy}
            />
          </div>
          {#if assignationMode === "AUTO" && !isCashback}
          <div class="field">
            <label for="sports-bonus-amount">
              Monto del bono
              {#if requiresBonusAmount}<span class="required">*</span>{:else}<span class="optional">(opcional)</span>{/if}
            </label>
            <div class="input-group">
              <span class="input-group-text">{campaign?.currency || "—"}</span>
              <input
                id="sports-bonus-amount"
                class="form-control"
                type="number"
                min="0.01"
                max={hasMaximumBonusAmount ? maximumBonusAmount : undefined}
                step="0.01"
                placeholder="0.00"
                bind:value={bonusAmount}
                disabled={busy}
              />
            </div>
            {#if hasMaximumBonusAmount}
              <div class="maximum-bonus-info" role="note">
                <span>
                  El máximo asignado para el bonus es
                  <strong>{campaign?.currency || ""} {maximumBonusAmount}</strong>.
                </span>
                <button
                  type="button"
                  class="use-maximum-button"
                  disabled={busy}
                  on:click={() => (bonusAmount = maximumBonusAmount)}
                >
                  Usar monto máximo
                </button>
              </div>
            {/if}
          </div>
          {/if}
        </div>
        <p class="config-help mb-0">
          Esta configuración se guarda únicamente en el sistema y será utilizada por las asignaciones manuales y automáticas.
        </p>
        {#if errorMessage}<div class="alert alert-danger mb-0 mt-3" role="alert">{errorMessage}</div>{/if}
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" disabled={busy} on:click={() => dispatch("close")}>Cancelar</button>
        <button type="button" class="btn btn-primary" disabled={busy} on:click={save}>{busy ? "Guardando…" : "Guardar"}</button>
      </div>
    </div>
  </div>
</div>

<style>
  .config-modal { max-width: 640px; }
  .campaign-name { margin-top: 0.15rem; color: #6c757d; font-size: 0.85rem; }
  .config-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; }
  .config-grid.single-field { grid-template-columns: 1fr; }
  .field { min-width: 0; }
  .field label, .field-label { display: block; margin-bottom: 0.35rem; color: #555; font-size: 0.82rem; font-weight: 600; }
  .required { color: #dc3545; }
  .optional { color: #6c757d; font-weight: 400; }
  .config-help { margin-top: 1rem; color: #6c757d; font-size: 0.8rem; }
  .maximum-bonus-info { display: flex; align-items: baseline; justify-content: space-between; gap: 0.75rem; margin-top: 0.45rem; color: #664d03; font-size: 0.78rem; }
  .use-maximum-button { flex: 0 0 auto; padding: 0; border: 0; background: transparent; color: #0d6efd; font-size: 0.78rem; font-weight: 600; text-decoration: underline; text-underline-offset: 2px; }
  .use-maximum-button:hover:not(:disabled) { color: #0a58ca; }
  .use-maximum-button:disabled { cursor: not-allowed; opacity: 0.55; }
  @media (max-width: 640px) { .config-grid { grid-template-columns: 1fr; } }
</style>
